import React from 'react';
import {
  ClipboardList,
  Database,
  History,
  LayoutDashboard,
  LogOut,
  Users,
  X
} from 'lucide-react';

export default function AppSidebar({
  open,
  onClose,
  active = 'dashboard',
  onLogout
}) {
  const username = localStorage.getItem('username') || '';
  const role = localStorage.getItem('role') || '';
  const isAdmin = role === 'admin';
  const isArchitect = role === 'architect';

  const go = (href) => {
    onClose?.();
    window.location.href = href;
  };

  return (
    <>
      <div
        className={`sidebar-backdrop${open ? ' is-open' : ''}`}
        onClick={onClose}
        aria-hidden={!open}
      />
      <aside className={`app-sidebar${open ? ' is-open' : ''}`} aria-label="Main navigation">
        <div className="sidebar-brand">
          <div className="sidebar-brand-main">
            <Database size={22} />
            <div>
              <strong>Client Management</strong>
              <span>Workspace</span>
            </div>
          </div>
          <button
            type="button"
            className="sidebar-close"
            onClick={onClose}
            aria-label="Close sidebar"
          >
            <X size={18} />
          </button>
        </div>

        <nav className="sidebar-nav">
          <p className="sidebar-section-label">Menu</p>
          <button
            type="button"
            className={`sidebar-link${active === 'dashboard' ? ' is-active' : ''}`}
            onClick={() => go('/dashboard')}
          >
            <LayoutDashboard size={18} />
            Dashboard
          </button>

          {isArchitect && (
            <button
              type="button"
              className={`sidebar-link${active === 'tasks' ? ' is-active' : ''}`}
              onClick={() => go('/tasks')}
            >
              <ClipboardList size={18} />
              My Tasks
            </button>
          )}

          {isAdmin && (
            <>
              <button
                type="button"
                className={`sidebar-link${active === 'users' ? ' is-active' : ''}`}
                onClick={() => go('/admin/users')}
              >
                <Users size={18} />
                Manage Users
              </button>
              <button
                type="button"
                className={`sidebar-link${active === 'activity' ? ' is-active' : ''}`}
                onClick={() => go('/admin/activity')}
              >
                <History size={18} />
                Activity Log
              </button>
            </>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="sidebar-user-avatar" aria-hidden="true">
              {(username || 'U').slice(0, 1).toUpperCase()}
            </div>
            <div className="sidebar-user-meta">
              <strong>{username || 'User'}</strong>
              <span>{role || 'member'}</span>
            </div>
          </div>
          <button type="button" className="sidebar-link sidebar-link--danger" onClick={onLogout}>
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </aside>
    </>
  );
}
